var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFilter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "filter_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 5261",
  fill: "none",
  d: "M0 0h20v20H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33969",
  clipPath: "url(#filter_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13274",
  d: "M7.635 20a.833.833 0 0 1-.833-.833V12.3a1.024 1.024 0 0 0-.2-.613L.92 4.085A4.722 4.722 0 0 1 0 1.269 1.251 1.251 0 0 1 1.227 0h17.545A1.251 1.251 0 0 1 20 1.269a4.722 4.722 0 0 1-.92 2.815l-5.685 7.6a1.031 1.031 0 0 0-.2.613v5.034a.833.833 0 0 1-.532.777l-4.728 1.836a.828.828 0 0 1-.3.056M1.692 1.667a3 3 0 0 0 .563 1.42l5.685 7.6a2.7 2.7 0 0 1 .528 1.613v5.65l3.065-1.188V12.3a2.7 2.7 0 0 1 .527-1.611l5.685-7.6a3 3 0 0 0 .563-1.42Z",
  fill: "currentColor"
}))));
export default SvgFilter;